/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const VeloFavicon = ({size, ...props}) => (
  <svg viewBox="0 0 16 16" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <circle cx="8" cy="8" r="7" fill="#fff" />
    <path d="M1,8c0,3.9,3.1,7,7,7s7-3.1,7-7c0-3.9-3.1-7-7-7C5.8,1,3.9,2,2.6,3.6c1.5,0.3,2.6,1.1,3.7,3.1	c1.3,2.3,1,4,1.8,4c1.1,0,1.3-3.4,1.6-4.2h1.7c-0.1,0.5-0.9,3.9-1.2,4.5c-0.6,1.1-1.4,1.3-2,1.3c-1.6,0-2-1.3-2.3-2.3	c-0.3-1-0.6-1.8-1-2.5C3.5,4.9,1.7,5.1,1.6,5.1C1.2,6,1,7,1,8z"
      fill="#3536e5" />
  </svg>
);
VeloFavicon.displayName = 'VeloFavicon';
VeloFavicon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
